import type { WrapperFC } from '@george-labs.com/design-system';
import { Avatar, SkeletonAvatar } from '@george-labs.com/design-system';
import type { AvatarProps } from '@george-labs.com/design-system/types/components/Image/Avatar';

import { useSecureImage } from '../useSecureImage';

type Props = AvatarProps & {
    sendImageVariant?: boolean;
};

const SEND_ACCEPT_HEADER = true;
const METHOD = 'GET';

export const SecureAvatar: WrapperFC<Props> = ({
    imageUrl,
    sendImageVariant = true,
    ...restProps
}) => {
    const { imageData, isLoading } = useSecureImage(
        imageUrl,
        SEND_ACCEPT_HEADER,
        METHOD,
        sendImageVariant,
    );

    if (isLoading) {
        return <SkeletonAvatar animated size={restProps.size} className={restProps.className} />;
    }

    return <Avatar imageUrl={imageData} {...restProps} />;
};

SecureAvatar.wrapsComponent = Avatar;
